// src/crm/ugc/InviteDialog.tsx
//
// Invitation au portail d'un contact `ugc_creator` qui n'est pas membre (spec § 6.5) : adresse de
// connexion préremplie, « Peut faire des factures ? », envoi d'un lien de connexion valable 7 jours.
// Formulaire dans la page (pas de fenêtre modale), comme les autres confirmations du programme.

import { useId, useState, type FormEvent } from 'react'
import { useInviteMember } from './hooks'

export function InviteDialog({
  creatorId,
  defaultEmail,
  onClose,
}: {
  creatorId: string
  defaultEmail: string
  onClose: () => void
}) {
  const invite = useInviteMember()
  const emailId = useId()
  const [email, setEmail] = useState(defaultEmail)
  const [canInvoice, setCanInvoice] = useState(false)

  function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()
    invite.mutate({ creatorId, email: email.trim(), canInvoice }, { onSuccess: onClose })
  }

  return (
    <form className="ugc-inline-form" onSubmit={submit}>
      <label htmlFor={emailId}>E-mail de connexion</label>
      <input
        id={emailId}
        className="ugc-input"
        type="email"
        required
        autoComplete="off"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <label className="ugc-check">
        <input type="checkbox" checked={canInvoice} onChange={(e) => setCanInvoice(e.target.checked)} />
        <span>Peut faire des factures ?</span>
      </label>
      <p className="ugc-muted">Un lien de connexion valable 7 jours part à cette adresse.</p>
      <div className="ugc-actions">
        <button type="submit" className="ugc-btn ugc-btn--go" disabled={invite.isPending || email.trim() === ''}>
          {invite.isPending ? 'Envoi…' : "Envoyer l'invitation"}
        </button>
        <button type="button" className="ugc-btn" disabled={invite.isPending} onClick={onClose}>
          Annuler
        </button>
      </div>
      {invite.error && (
        <p role="alert" className="ugc-error">
          {invite.error.message}
        </p>
      )}
    </form>
  )
}
